import { css } from 'styled-components';
import FONTS from '../constants/fonts.js';
import FontSize from '../constants/fontSize.js';
import '../constants/colors.js';
import { Breakpoint } from '../constants/breakpoint.js';
import '../constants/theme.js';
import '../constants/files.js';
import '../constants/color-variant.js';
import '../constants/zIndexList.js';

const fontWeightMixin = css `
    font-family: ${({ weight }) => weight && FONTS[weight.toUpperCase()]};
`;
const getCommonFontStyleMixin = (props) => {
    const { size, mSize, weight } = props;
    return css `
        ${css(Object.assign(Object.assign({}, (weight && {
        fontFamily: FONTS[weight.toUpperCase()],
    })), (size && {
        fontSize: `${FontSize[size]}rem`,
    })))}

        @media (max-width: ${Breakpoint.mobileBreakpointMaxWidth}) {
            ${css(Object.assign({}, (mSize && {
        fontSize: `${FontSize[mSize]}rem`,
    })))}
        }
    `;
};

export { fontWeightMixin, getCommonFontStyleMixin };
//# sourceMappingURL=font.js.map
